export type { IResponseEnvelope as BaseResponse } from 'interfaces/response-envelope.interface'

export interface PaginationParams {
  page: number
  limit: number
}

export interface ApiErrorData {
  code: string
  message: string
  details?: Record<string, unknown>
}

export class ApiError extends Error {
  readonly status: number
  readonly code: string
  readonly details?: Record<string, unknown>

  constructor(status: number, data: ApiErrorData) {
    super(data.message)
    this.name = 'ApiError'
    this.status = status
    this.code = data.code
    this.details = data.details
  }
}
